export const NONEXISTENTFORMID = 'NONEXISTENTFORMID'; // in order to not have the value in the formdata when undetermined
